import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../../components/shapes/Line'
import { SmallText } from '../../../../components/presentation/Text'
import Separator from '../../../../components/helpers/Separator'
import Textarea from '../../../../components/form/Textarea'

const ReplyNotesInput = ({ value, open, handleChange }) => {
  if (!open) return false

  return (
    <div>
      <Separator weight={4} />
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />
      <SmallText size="xsmall">Anotações</SmallText>
      <Separator />
      <Textarea value={value} onStopTyping={handleChange} />
    </div>
  )
}

export default ReplyNotesInput
